import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, Button, Input, DropdownButton, MenuItem, InputGroup } from 'react-bootstrap';
import { Translate, Localize } from 'react-redux-i18n';

class VendorForm extends Component {
  componentDidMount() {
  }

  handleFormSubmit(formProps) {
  }

  render() {
    const { handleSubmit, closeV } = this.props;
    return (
      <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
        <Row>
          <Col sm={ 6 }>
            <div className="form-group">
              <label><Translate value="customer_name" /></label>
              <Field name="Name" component="Input" type="text" className="form-control"/>
            </div>
          </Col>
          <Col sm = { 3 }>
            <div className="form-group">
              <label><Translate value="customer_no" /></label>
              <Field name="TermDays" component="Input" type="text" className="form-control"/>
            </div>
          </Col>
          <Col sm = { 3 }>
            <div className="form-group">
              <label><Translate value="description" /></label>
              <Field name="Description" component="Input" className="form-control"/>
            </div>
          </Col>
        </Row>
        <button action="submit" className="btn btn-primary buttonStyle" ><Translate value="submit" /></button>
        <button className="btn btn-danger buttonStyle" onClick={(event) => { event.preventDefault(); closeV(); } } ><Translate value="cancel" /></button>
      </form>
    )
  }
}

export default VendorForm;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/vendorForm.jsx